/**
 * To avoid merge conflicts, please add new feature flags to a random location (not the last line).
 */
enum featureFlags {
  DEMO_PAGE_DATAGRID_V4 = 'demo-page-datagrid-v4',
  EAG_GRID = 'eag_grid',
  IAM_LOGIN = 'iam_login',
  SETTINGS_MANAGEMENT_SPLIT = 'core_settings_management_split',
  NOTIFICATION_CENTER = 'notification_center',
  BUSINESS_CASE_PRICING_SIMPLIFIED = 'business_case_pricing_simplified',
  BC_SOURCE = 'bc_source',
  BUSINESS_CASE_OVERVIEW = 'business_case_overview',
  BUSINESS_CASE_ONLINE_OFFER = 'business_case_online_offer',
  DIGITAL_SIGNATURE = 'core_document_signature',
  USER_INVITATION = 'core_user_invitation',
  SALES_BROKERAGE_CONTRACT_CANCELLATION = 'sales_brokerage_contract_cancelation',
  ACCOUNTING_CANCEL_V2 = 'core_accounting_canceling_v2',
  SALES_PRE_ACCOUNTING = 'sales_pre_accounting',
  TENANT_V2 = 'pl_addresses_in_tenant_settings',
  AI_VEHICLE_SERVICE_INTERVALS = 'ai_service_intervals',
  AI_LEAD_MANAGEMENT = 'core_ai_lead_management',
  AI_LEAD_LOG = 'core_ai_lead_log',
  USER_DETAIL_V2 = 'core_user_detail_v2',
  MY_PROFILE_AVATAR = 'avatar_in_my_profile',
  SALES_360_VEHICLES = 'vehicle_360_view_datagrid',
  OS_BUSINESS_CASES = 'businesscases_360_view_datagrid',
  RETRY_INTERCEPTOR = 'retry_interceptor',
  AUTH_PROFILE_SELECTOR = 'auth_profile_selector',
  NOTIFICATION_SETTINGS = 'core_notification_settings',
  ENTITY_HEADER_V2 = 'entity_header_v2',
  SALES_CEBIA_REPORT_CLASSIFIED_PUBLISHING_SWITCH = 'sales_cebia_report_classified_publishing_switch',
  SALES_CEBIA_SMART_CODE_URL_PUBLISHING_SWITCH = 'sales_cebia_smart_code_url_publishing_switch',
  VEHICLE_HIGHLIGHTED_FEATURES = 'core_vehicle_highlighted_features',
  SALES_CENTRALIZED_PRICING = 'sales_buying_pricer_role',
  SALES_FEATURE_SCORING = 'acl_sales_feature_scoring',
  SALES_SUPPLIER_INVOICE = 'sales_supplier_invoice',
  SALES_VEHICLE_PRICE_SUMMARY = 'sales_vehicle_price_summary',
  ACL_REPORTING = 'acl_reporting',
  ACL_EMPLOYEE_MANAGEMENT = 'acl_employee_management',
  CRM_SALES_ACTIVITIES = 'crm_sales_activities',
  REDESIGN_ACTIVITY_SIDEBAR = 'redesign_activity_sidebar',
  SALES_BGR_BANNER = 'sales_bgr_banner',
  MAGIC_BUTTON = 'magic_button',
  VEHICLE_MILEAGE_HISTORY = 'vehicle_mileage_history',
  CORE_ACTIVITY_LOGS = 'core_activity_logs',
  CORE_NEWS_POPUP = 'core_news_popup',
  CORE_TEAMS = 'core_teams',
  CORE_BRANCH_OPENING_TIMES = 'core_branch_opening_times',
  SALES_VEHICLE_WAREHOUSE_MANAGEMENT = 'sales_vehicle_warehouse_management',
  VEHICLE_RESERVATION_FUTURE_AGREEMENT = 'vehicle_reservation_future_agreement',
  SALES_CUSTOM_MAKE_MODEL = 'sales_custom_make_model',
  ACCOUNTING_ADDITIONAL_CUSTOMER = 'sales_accounting_additional_customer',
  ADVERTISEMENT_GENERAL_SETTINGS = 'sales_ads_generalsettings',
  ADVERTISEMENT_VERSION_GENERATION_ATTRIBUTES = 'sales_ads_version_generation_attributes',
  ADVERTISEMENT_DIGITAL_CERTIFICATE_VIDEO_URL_ATTRIBUTES = 'sales_ads_digital_certificate_video_url_attributes',
  ADVERTISEMENT_RICH_TEXT_DESCRIPTION = 'sales_ads_rich_text_description',
  AUTOSTACJA_CUSTOMER_WIDGET = 'autostacja_customer_widget',
  SETTINGS_FACEBOOK = 'settings_facebook',
  OUTLOOK_INTEGRATION = 'outlook_integration',
  WHATSAPP_INTEGRATION = 'whatsapp_integration',
  SETTINGS_JBR = 'settings_jbr',
  SETTINGS_TWO_FACTOR_AUTH = 'core_settings_two_factor',
  NOTIFICATIONS_COMMENT_MENTION = 'notifications_comment_mention',
  VEHICLE_CUSTOM_FIELDS = 'vehicle_custom_fields',
  INTEREST_CLONE_FLOW = 'interest_clone_flow',
  INTEREST_CUSTOM_FIELDS = 'interest_custom_fields',
  CUSTOMER_CUSTOM_FIELDS = 'customer_custom_fields',
  BUSINESS_CASE_CUSTOM_FIELDS = 'business_case_custom_fields',
  SALES_BC_SOURCE = 'sales_bc_source',
  SIDEBAR_REMOVE_QUICK_ACTIONS = 'sidebar_remove_quick_actions',
  ACCOUNTING_MARGIN_INVOICES = 'core_accounting_margin_invoices',
  SALES_CLAIMS = 'sales_claims',
  REPLACE_VEHICLE_DG_WITH_OPENSEARCH = 'replace_vehicle_dg_with_opensearch',
  VEHICLE_MULTIPLE_ALBUMS = 'vehicle_multiple_albums',
  SALES_INSURANCE_COMPARISON_V1 = 'sales_insurance_comparison_v1',
  SALES_TEST_DRIVES_V2 = 'sales_testdrives_v2',
  SALES_SALE_PROGRAMS = 'sales_sale_programs',
  VEHICLE_PRICEREPORT_WIDGET_FORM = 'vehicle_pricereport_widget_form',
  CORE_CUSTOM_USER_ID = 'core_custom_userid',
  MY_PROFILE = 'my_profile',
  REMOVE_VEHICLE_FROM_SALE = 'remove_vehicle_from_sale',
  CORE_CUSTOMER_GROUPS = 'core_customer_groups',
  CORE_FINANCING_INFORMATION_V2 = 'core_financing_information_v2',
  SALE_INTEREST_ACTION_LOG = 'sale_interest_action_log',
  SALES_MOT_VALIDITY = 'sales_mot_validity',
  SALES_ACTION_LOG_CUSTOMER = 'sales_action_log_customer',
  VERSION_LOG_DUMP = 'version_log_dump',
  VEHICLE_HEADER_V3 = 'vehicle_header_v3',
  SALES_PHOTO_ROTATION = 'sales_photo_rotation',
  SALES_VGP_CERTIFICATES = 'sales_vgp_certificates',
  EMPLOYEE_AVATARS = 'core_employee_avatars',
  CONFIGURABLE_MANDATORY_FIELDS = 'configurable_mandatory_fields',
  CORE_GDPR_DATAGRID = 'core_gdpr_datagrid',
  CORE_NUMBER_OF_DOCUMENTS = 'core_number_of_documents',
  VEHICLE_FINANCIAL_INSTITUTION = 'vehicle_financial_institution',
  VEHICLE_THREE_HUNDRED_AND_SIXTY_PHOTOS = 'vehicle_three_hundred_and_sixty_photos',
  SALES_FAST_BUYING = 'sales_fast_buying',
  SALES_FAST_PRICING = 'sales_fast_pricing',
  SCRIPT_BEAMER = 'script_beamer',
  SALES_VEHICLE_ORIGINAL_PRICE = 'sales_vehicle_original_price',
  CKK_CONSENT_STATUS_FLOW = 'ckk_consent_status_flow',
  SETTINGS_WATERMARKS = 'settings_watermarks',
  SETTINGS_WATERMARKS_CATEGORIES = 'settings_watermarks_categories',
  SALES_VEHICLE_WAREHOUSE_SALESINFO = 'sales_vehicle_warehouse_salesinfo',
  SALES_SALE_VEHICLE_COMMENTS = 'sales_comments_for_sale_vehicle',
  SETTINGS_ADVERTISEMENT_MULTIBRANCH = 'settings_advertisement_multibranch',
  SETTINGS_ADVERTISEMENT_AUTOMATIC_UPDATE = 'settings_advertisement_automatic_update',
  SETTINGS_ADVERTISEMENT_DESCRIPTION_GENERATOR = 'settings_advertisement_description_generator',
  INTEREST_CUSTOMER_INQUIRY = 'interest_customer_inquiry',
  SALES_VEHICLE_INSURANCE = 'sales_vehicle_insurance',
  SALES_FEATURES_ADDITIONAL_INFO = 'sales_features_additional_info',
  SALES_AUTOCANCEL_RESERVATION = 'sales_autocancel_reservation',
  CUSTOMER_ABROAD_SALE_SETTING = 'customer_abroad_sale_setting',
  SALES_VEHICLE_DAT_DECODER = 'sales_vehicle_dat_decoder',
  AFS_WAREHOUSE_TRANSFER_ORDER = 'afs_warehouse_transfer_order',
  ACL_VAT_CALCULATION_DEFINITION = 'acl_vat_calculation_definition',
  DG_SHARED_PRESETS = 'dg_shared_presets_',
  ACL_VAT_CHECK_DEFINITION = 'acl_vat_check_definition',
  ACL_NEGATIVE_DOCUMENT_CANCELLATION_DEFINITION = 'acl_negative_document_cancellation_definition',
  ADVERTISEMENT_FAKE_PLATFORMS = 'advertisement_fake_platforms',
  ADVERTISEMENT_FACEBOOK = 'advertisement_facebook',
  ADVERTISEMENT_MERCEDES_NA_SKLADE_REST = 'advertisement_mercedes_na_sklade_rest',
  ADVERTISEMENT_SAMOCHODY_PL = 'advertisement_samochody_pl',
  DG_SHARE_CUSTOM_PRESET_COPY = 'dg_share_custom_preset_copy', // Will become used after [T20-52058]
  INSPECTION_TO_REVISION_NO_EDIT = 'inspection_to_revision_no_edit',
  PLATFORM_LIGHTBOX = 'platform_lightbox',
  SALES_INTEREST_LEADQUALITY = 'sales_interest_leadquality',
  INTERESTS_UTM = 'interests_utm',
  SALE_VEHICLE_OPENSEARCH = 'sale_vehicle_opensearch',
  CORE_MAX_POWER = 'core_max_power',
  MESSAGE_TEMPLATES = 'message_templates',
  MESSAGE_EMAIL_REDESIGN_AFTERSALES = 'message_email_redesign_aftersales',
  MERCEDES_BACKGROUND_PHOTOS = 'mercedes_background_photos',
  MERCEDES_BACKGROUND_ZIZAK = 'mercedes_background_zizak',
  MERCEDES_BACKGROUND_VSP = 'mercedes_background_vsp',
  MERCEDES_BACKGROUND_SW = 'mercedes_background_s&w',
  DAVOCAR_BACKGROUND = 'background_davocar',
  VSP_BACKGROUND = 'background_vsp',
  ACL_DOCUMENTS = 'acl_documents',
  OMNETIC_VIN_DECODER = 'omnetic_vin_decoder',
  SALES_BR_CUSTOM_LICENSE_PLATE = 'sales_br_custom_license_plate',
  CORE_TASK_MANAGEMENT = 'core_task_management',
  CORE_TASK_CALENDAR = 'core_task_calendar',
  CORE_TASK_MANAGEMENT_BANNER = 'core_taskmgmt_banner',
  CORE_DIGISIGN_BANNER = 'core_digisign_banner',
  CORE_AI_DESCRIPTION_BANNER = 'core_ai_description_banner',
  CORE_CHAT_BANNER = 'core_chat_banner',
  SALE_TASKS_CHECKLIST = 'sale_tasks_checklist',
  SALES_COSTS_WITH_VAT = 'sales_costs_with_vat',
  IMPORT_MODULE = 'import_module',
  CAR_VERTICAL_INTEGRATION = 'car_vertical_integration',
  MIRA_PREDICTIVE_MAINTENANCE = 'mira_predictive_maintenance',
  AUTOTRACER_PL = 'autotracer_pl',
  CHAT_FEATURE = 'chat_feature',
  VEHICLE_PREMIUM_FEATURES = 'vehicle_premium_features',
  WORKSHOP_INTEREST = 'workshop_interest',
  AFS_WAREHOUSE_ARTICLE_UPDATE_JOB = 'afs_warehouse_article_update_job',
  AFS_WAREHOUSE_FAST_TRACK_ISSUE = 'warehouse_fast_track_issue',
  AFS_WAREHOUSE_DELIVERY_NOTE_DOCUMENT_PREVIEW = 'afs_warehouse_delivery_note_document_preview',
  AFS_WAREHOUSE_EXTRACT_DELIVERY_NOTE = 'afs_warehouse_extract_delivery_note',
  OFFER_VALIDITY = 'offer_validity',
  ONLINE_OFFER_DISCLAIMER = 'online_offer_disclaimer',
  ONLINE_OFFER_SETTINGS = 'online_offer_settings',
  SOURCING_SUSPICIOUS_VEHICLES = 'sourcing_suspicious_vehicles',
  SOURCING_HITLIST_BLACKLIST = 'sourcing_hitlist_blacklist',
  SOURCING_ATTRACTIVENESS_SCORE = 'sourcing_attractiveness_score',
  SALES_BE_HANDOVER_DOCS = 'sales_be_handover_docs',
  DASHBOARD_FAST_PRICING_BUTTON = 'dashboard_fast_pricing_button',
  SOURCING_PRICE_CHANGES = 'sourcing_price_changes',
  SOURCING_REAL_TIME_ADVERTISEMENT = 'sourcing_real_time_advertisement',
  SOURCING_CARVAGO_BUY = 'sourcing_carvago_buy',
  SOURCING_FILTER_POSITION = 'sourcing_filter_position',
  AUTH_PROFILES_TEMPLATES = 'auth_profiles_templates',
  SCHEDULED_MESSAGES = 'scheduled_messages',
  ADVERTISEMENT_VGP = 'advertisement_vgp',
  ADVERTISEMENT_AUDI_PL = 'advertisement_audi_pl',
  SOURCING_PRICE_MAP_STATISTICS = 'sourcing_price_map_statistics',
  SOURCING_AUCTIONS = 'sourcing_auctions',
}

export default featureFlags;
export {featureFlags};

/**
 * To avoid merge conflicts, please add new feature flags to a random location (not the last line).
 */
